import { render } from "./HeroComp.vue?vue&type=template&id=feb8fbaa"
import script from "./HeroComp.vue?vue&type=script&lang=js"
export * from "./HeroComp.vue?vue&type=script&lang=js"

import "./HeroComp.vue?vue&type=style&index=0&id=feb8fbaa&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__